import { withRBAC } from "../rbac";
import { ServiceTicketCreate } from './ServiceTicketCreate';
import { ServiceTicketEdit } from './ServiceTicketEdit';
import { ServiceTicketList } from './ServiceTicketList';
import { ServiceTicketShow } from './ServiceTicketShow';

export const service_tickets = {
    list: withRBAC(ServiceTicketList, "view_tickets"),
    show: withRBAC(ServiceTicketShow, "view_tickets"),
    create: withRBAC(ServiceTicketCreate, "manage_tickets"),
    edit: withRBAC(ServiceTicketEdit, "manage_tickets"),
};

